(ns env
  (:require-macros [env]))

; should be set at compile-time via :closure-defines
(goog-define ^boolean dev false)

(println "env/dev is" dev)